/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'app/utils/loadable';

export const GlobalThemesPage = lazyLoad(
  () => import('./index'),
  module => module.GlobalThemesPage,
);
